import { PaintedScene } from '../PaintedScene';

export const CHAR_GARDEN_PHASER_KEY = 'CharGardenScene' as const;
export const CHAR_GARDEN_MANIFEST_KEY = 's-413-char-garden' as const;

export class CharGardenScene extends PaintedScene {
  constructor() {
    super(CHAR_GARDEN_PHASER_KEY, CHAR_GARDEN_MANIFEST_KEY);
  }
}
